
import { Row, Col, Container, Nav, Dropdown, Carousel, Table, Form, Button } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { FaPlus } from 'react-icons/fa';
import MakeRequest from '../Helpers/MakeRequest';
import axios from 'axios';
import apiUrl from '../Helpers/APIWrapper';
import { useOutletContext } from 'react-router-dom';
import ReactQuill from "react-quill";
import QuillExports from '../Helpers/QuillHelpers';
import toBlob from '../Helpers/FileBlobs';

const EditHome = () => {
    const { l } = useOutletContext();
    const { quillModules, quillFormats } = QuillExports();

    const [carouselCards, setCarouselCards] = useState([]);
    const [subtitleContent, setSubtitleContent] = useState([]);
    const [buttonDisabled, setButtonDisabled] = useState(false);

    useEffect(() => {
        const fetchMenuItems = async () => {
            const homeContentRes = await MakeRequest({}, 'content/pageContent?page=home', 'get');
            if (homeContentRes.data) {


                const carouselCards = homeContentRes.data.filter(obj => obj.page === "home" && obj.type === "carousel")
                setCarouselCards(carouselCards ?? []);

                const subtitle = homeContentRes.data.filter(obj => obj.page === "home" && obj.type === "subtitle")


                setSubtitleContent(subtitle)
            };
        };
        fetchMenuItems();
    }, []);

    const handleSaveChanges = async () => {

        if (carouselCards.some(CC => !CC.card.imgSrc.file)) {
            alert(l('Vänligen lägg in bilder på samtliga poster', 'Please insert images on all slides'))
            return;
        };

        try {
            const formData = new FormData();
            carouselCards.forEach((CC, idx) => {
                if (CC.card.imgSrc.file && CC.card.imgSrc.file.startsWith('data:')) {
                    const blob = toBlob(CC.card.imgSrc.file);
                    formData.append('images', blob, `${CC.card.imgSrc.name}`);
                    formData.append(`imageName-${idx}`, CC.card.imgSrc.name);
                }
                formData.append(`id-${idx}`, CC._id);
                formData.append(`titleSwe-${idx}`, CC.card.titleSwe);
                formData.append(`contentSwe-${idx}`, CC.card.contentSwe);
                formData.append(`titleEng-${idx}`, CC.card.titleEng);
                formData.append(`contentEng-${idx}`, CC.card.contentEng);
            });

            subtitleContent.forEach((sub, idx) => {
                if (sub.imgSrc?.file && sub.imgSrc.file.startsWith('data:')) {
                    const blob = toBlob(sub.imgSrc.file);
                    formData.append(`images`, blob, `${sub.imgSrc.name}`);
                    formData.append(`subImageName-${idx}`, sub.imgSrc.name);
                };
                formData.append(`subId-${idx}`, sub._id);
                formData.append(`subTitleSwe-${idx}`, sub.content.contentSwe || '');
                formData.append(`subTitleEng-${idx}`, sub.content.contentEng || '');
            });


            const response = await axios.post(
                `${apiUrl}/content/home`,
                formData,
                {
                    withCredentials: true
                }
            );

            alert('Changes saved!');
            window.location.reload();
        } catch (error) {

            if (typeof error.response?.data === "string" && error.response?.data.includes("already exists")) {
                alert(l('Filnamnet finns redan', 'File name already exists'))
            } else {
                console.error('Error saving changes:', error);
                alert('Failed to save changes.');
            }
        }
    };

    const handleAddItem = () => {
        setCarouselCards([...carouselCards, {
            page: 'home',
            type: 'carousel',
            card: {
                imgSrc: '', titleSwe: '', contentSwe: '', titleEng: '', contentEng: ''
            }
        }]);
    };

    const handleAddSubtitle = () => {
        setSubtitleContent([...subtitleContent, {
            page: 'home',
            content: {
                contentSwe: '',
                contentEng: ''
            }
        }]);
    };

    const handleImageChange = (e, idx) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const newCc = [...carouselCards];
                newCc[idx]['card'].imgSrc = {
                    file: reader.result,
                    name: file.name
                };
                setCarouselCards(newCc);
            };
            reader.readAsDataURL(file);
        };
    };

    const handleDetailChange = (e, idx, field) => {
        const newCc = [...carouselCards];
        newCc[idx]['card'][field] = e.target.value;
        setCarouselCards(newCc);
    };

    const handleSubtitleChange = (field, val, idx) => {
        const newSubtitles = [...subtitleContent];
        newSubtitles[idx].content[field] = val;
        setSubtitleContent(newSubtitles);
    };

    const handleDeleteItem = async (idx) => {

        if (!carouselCards[idx]._id) {
            setCarouselCards(carouselCards.filter((_, i) => i !== idx));
            return;
        };

        if (window.confirm(l("Är du säker på att du vill ta bort denna bild?", "Are you sure you want to delete this slide?"))) {
            try {
                const res = await MakeRequest({ id: carouselCards[idx]._id }, `content/home/slide/${carouselCards[idx]._id}`, 'delete');
                if (res.status === 200) {
                    setCarouselCards(carouselCards.filter((_, i) => i !== idx));
                    alert(l("Bild borttagen.", "Slide deleted successfully"));
                } else {
                    alert(l("Misslyckades med att ta bort bild.", "Failed to delete slide"));
                }
            } catch (error) {
                console.error("Failed to delete retailer:", error);
            }
        }
    };

    const handleDeleteSubtitle = async (idx) => {
        if (!subtitleContent[idx]._id) {
            setSubtitleContent(subtitleContent.filter((_, i) => i !== idx));
            return;
        }
        if (window.confirm(l("Är du säker på att du vill ta bort denna underrubrik?", "Are you sure you want to delete this subtitle?"))) {
            try {
                const res = await MakeRequest({ id: subtitleContent[idx]._id }, `content/home/subtitle/${subtitleContent[idx]._id}`, 'delete');
                if (res.status === 200) {
                    setSubtitleContent(subtitleContent.filter((_, i) => i !== idx));
                    alert(l("Underrubrik borttagen.", "Subtitle deleted successfully"));
                } else {
                    alert(l("Misslyckades med att ta bort underrubrik.", "Failed to delete subtitle"));
                }
            } catch (error) {
                console.error("Failed to delete subtitle:", error);
            }
        }
    };

    return (
        <>
            <Row>
                <Form.Label column sm={2} style={{ fontWeight: 'bold' }}>
                    {l('Bildspel', 'Slideshow')}
                    <Button
                        size="sm"
                        style={{ marginLeft: 10 }}
                        onClick={handleAddItem}
                        title="Add new row"
                    >
                        <i className="fa-solid fa-plus"></i>
                    </Button>
                </Form.Label>
                <>
                    {/* Table view (desktop & large screens) */}
                    <Table striped bordered hover responsive className="d-none d-lg-table">
                        <thead>
                            <tr>
                                <th>{l("Bild", "Image")}</th>
                                <th>{l("Svenska", "Swedish")}</th>
                                <th>{l("Engelska", "English")}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {carouselCards.map((cc, idx) => (
                                <React.Fragment key={idx}>
                                    {/* First row: titles */}
                                    <tr>
                                        <td rowSpan={2}>
                                            {cc.card.imgSrc.file && (
                                                <img
                                                    src={cc.card.imgSrc.file}
                                                    alt="Example"
                                                    style={{ width: "100px", display: "block", marginBottom: "8px" }}
                                                />
                                            )}
                                            <Form.Group controlId={`formFile${idx}`}>
                                                <Form.Control
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => handleImageChange(e, idx)}
                                                />
                                            </Form.Group>
                                        </td>

                                        {/* SWE title */}
                                        <td>
                                            <Form.Control
                                                type="text"
                                                placeholder={l("Titel", "Title")}
                                                value={cc.card.titleSwe}
                                                onChange={(e) => handleDetailChange(e, idx, "titleSwe")}
                                            />
                                        </td>

                                        {/* ENG title */}
                                        <td>
                                            <Form.Control
                                                type="text"
                                                placeholder={l("Titel", "Title")}
                                                value={cc.card.titleEng}
                                                onChange={(e) => handleDetailChange(e, idx, "titleEng")}
                                            />
                                        </td>

                                        {/* delete button */}
                                        <td rowSpan={2}>
                                            <Button onClick={() => handleDeleteItem(idx)}>
                                                <i className="fa-solid fa-trash"></i>
                                            </Button>
                                        </td>
                                    </tr>

                                    {/* Second row: contents */}
                                    <tr>
                                        <td>
                                            <Form.Control
                                                as="textarea"
                                                placeholder={l("Innehåll", "Content")}
                                                value={cc.card.contentSwe}
                                                onChange={(e) => handleDetailChange(e, idx, "contentSwe")}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                as="textarea"
                                                placeholder={l("Innehåll", "Content")}
                                                value={cc.card.contentEng}
                                                onChange={(e) => handleDetailChange(e, idx, "contentEng")}
                                            />
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>

                    {/* Card view (mobile & tablet) */}
                    <div className="d-block d-lg-none p-0 m-0">
                        {carouselCards.map((cc, idx) => (
                            <div key={idx} className="card mb-3 p-3">
                                {cc.card.imgSrc.file && (
                                    <img
                                        src={cc.card.imgSrc.file}
                                        alt="Example"
                                        style={{ width: "100px", display: "block", marginBottom: "8px" }}
                                    />
                                )}
                                <Form.Group controlId={`formFileMobile${idx}`}>
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => handleImageChange(e, idx)}
                                    />
                                </Form.Group>

                                {/* SWE fields */}
                                <Form.Label className="mt-2">{l("Svenska", "Swedish")}</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder={l("Titel", "Title")}
                                    value={cc.card.titleSwe}
                                    onChange={(e) => handleDetailChange(e, idx, "titleSwe")}
                                    className="mb-2"
                                />
                                <Form.Control
                                    as="textarea"
                                    placeholder={l("Innehåll", "Content")}
                                    value={cc.card.contentSwe}
                                    onChange={(e) => handleDetailChange(e, idx, "contentSwe")}
                                    className="mb-3"
                                />

                                {/* ENG fields */}
                                <Form.Label>{l("Engelska", "English")}</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder={l("Titel", "Title")}
                                    value={cc.card.titleEng}
                                    onChange={(e) => handleDetailChange(e, idx, "titleEng")}
                                    className="mb-2"
                                />
                                <Form.Control
                                    as="textarea"
                                    placeholder={l("Innehåll", "Content")}
                                    value={cc.card.contentEng}
                                    onChange={(e) => handleDetailChange(e, idx, "contentEng")}
                                    className="mb-3"
                                />

                                {/* delete */}
                                <Button onClick={() => handleDeleteItem(idx)}>
                                    <i className="fa-solid fa-trash"></i> {l("Ta bort", "Delete")}
                                </Button>
                            </div>
                        ))}
                    </div>
                </>
            </Row>

            <Form.Label>
                <b>{l('Underrubriker', 'Subtitles')}</b>
                <Button
                    size="sm"
                    style={{ marginLeft: 10 }}
                    onClick={handleAddSubtitle}
                    title="Add new row"
                >
                    <i className="fa-solid fa-plus"></i>
                </Button>
            </Form.Label>

            {subtitleContent?.map((sub, idx) => (<>
                <Container style={{ border: "1px solid lightgray", padding: "16px", marginBottom: "16px", borderRadius: "8px", backgroundColor: "white" }} key={`container-${idx}`}>


                    <Row key={`subtitle-${idx}`}>
                        <Col lg={6} md={12} className=''>
                            <Form.Label column style={{ fontWeight: 'bold' }}>{l('Innehåll (Svenska)', 'Content (Swedish)')}</Form.Label>
                            <ReactQuill
                                theme="snow"
                                value={sub.content.contentSwe}
                                onChange={(val) => handleSubtitleChange('contentSwe', val, idx)}
                                modules={quillModules}
                                formats={quillFormats}
                                placeholder={l('Innehåll', 'Content')}
                                style={{ backgroundColor: "white" }}
                            />
                        </Col>
                        <Col lg={6} md={12} className=''>
                            <Form.Label column style={{ fontWeight: 'bold' }}>{l('Innehåll (Engelska)', 'Content (English)')}</Form.Label>
                            <ReactQuill
                                theme="snow"
                                value={sub.content.contentEng}
                                onChange={(val) => handleSubtitleChange('contentEng', val, idx)}
                                modules={quillModules}
                                formats={quillFormats}
                                placeholder={l('Innehåll', 'Content')}
                                style={{ backgroundColor: "white" }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={6} lg={6} md={12} className='mt-3'>
                            <Form.Group controlId={`subtitleImage${idx}`}>
                                <Form.Label>{l('Bild', 'Image')}</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="image/*"
                                    onChange={e => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            const reader = new FileReader();
                                            reader.onloadend = () => {
                                                setSubtitleContent(prev => {
                                                    const updated = [...prev];
                                                    updated[idx] = {
                                                        ...updated[idx],
                                                        imgSrc: {
                                                            file: reader.result,
                                                            name: file.name
                                                        }
                                                    };
                                                    return updated;
                                                });
                                            };
                                            reader.readAsDataURL(file);
                                        }
                                    }}
                                />
                                {sub.imgSrc?.file && (
                                    <img
                                        src={sub.imgSrc.file}
                                        alt="Subtitle"
                                        style={{ width: "100px", marginTop: "8px" }}
                                    />
                                )}
                            </Form.Group>
                        </Col>
                        <Col xl={6} lg={6} md={12} className='d-flex align-items-end mt-3'>
                            <Button variant="danger" onClick={() => handleDeleteSubtitle(idx)}>
                                {l('Ta bort', 'Remove')}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </>))}

            <Row className='d-flex justify-content-center mt-4'>
                <Button style={{ width: "200px" }} onClick={handleSaveChanges} disabled={buttonDisabled}>
                    {l('Spara ändringar', 'Save Changes')}
                </Button>
            </Row>
        </>
    );
};

export default EditHome;
